export default "__VITE_ASSET__34b84c09__"